import * as moment from 'moment-timezone';

import { Component, OnInit, OnDestroy } from '@angular/core';
import { LangService } from '../../core/lang.service';
import { TimezoneService } from '../../core/timezone.service';
import { AuthService, getFrontendDomain, MPT_REMOTE_PROCTOR_URL } from '../../api/auth.service';
import { RoutesService } from '../../api/routes.service';
import { LoginGuardService } from '../../api/login-guard.service';
import { MyApplAccountService } from '../my-appl-account.service';
import { BreadcrumbsService, IBreadcrumbRoute } from '../../core/breadcrumbs.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import { AccountType } from '../../constants/account-types';
import { ApiFailCode } from '../../api/constants/access-controls';
import { IQuestionConfig } from '../../ui-item-maker/item-set-editor/models';
import { IAssessmentFrameworkDetail, IRoutingRule } from '../../ui-item-maker/item-set-editor/models/assessment-framework';
import { MptConnectionService } from '../mpt-connection.service';
import { IReport } from '../view-tt-report/view-tt-report.component';
import { SEBService } from '../seb.service';
import { attestationStepsDuringTest } from 'src/app/ui-landing/attestation/attestation.component';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { EDeliveryOption } from 'src/app/api/models/db/test-sessions.schema';
import { MIROTALK_EVENT_MESSAGE, MIROTALK_MESSAGE_EVENT_LIST, MirotalkMessageEvent, MPT_REMOTE_PROCTOR_DOMAIN, RemoteProctoringService } from 'src/app/api/remote-proctoring.service';

enum WarningModes {
  INVALID_SEB = 'INVALID_SEB',
  ACCEPT_ATTEST = 'ACCEPT_ATTEST',
  SELECT_LANG = 'SELECT_LANG',
  NOT_BOOKED_APPL = 'NOT_BOOKED_APPL',
  NO_QUESTIONS_FOUND = 'NO_QUESTIONS_FOUND',
  UNKNOWN = 'UNKNOWN',
  INVALID_SEB_BYOD = 'INVALID_SEB_BYOD',
  NOT_VERIFIED = 'NOT_VERIFIED'
}

export interface ITestAttemptRes {
  lang: string;
  question_index: number;
  section_index: number;
  attempt_key: string;
  attemptId: number;
  testDesign: ITestDesignPayload;
  questions: any[];
  questionStates: any;
  startedOn:any;
  date_time_start: any; /// date
  is_issue_reporting_enabled: number;
  time_ext_m: number;
  test_window_time: number;
  sections_meta:any;
  testFormId: number;
  is_not_verified: boolean;
  is_on_break?: boolean;
  attempt_hash?: string;
  is_conference_ready?: boolean;
  is_conference_requested?: boolean;
  session_invit_code?: string; // session invitation code
  delivery_format?: EDeliveryOption; // delivery format of the test, e.g. remote, in-person
  framework: string;
  serverTime?: number,
}

export interface ITestDesignPayload {
  label?: string;
  sections: ISectionDef[];
  panelModules?: IPanelModuleDef[];
  panelRouting?: {[key:string]: Array<IRoutingRule>};
  isPanelRoutingByNumCorrect?: boolean;
  questionDb?: {[key: number]: IQuestionConfig};
  testletIds?: any[];
  helpPageId__cache?:number,
  __meta?: ITestMeta; // likely deprecated... from sample questions
  referenceDocumentPages?: { itemId: number, caption: string }[];
}

export interface IQuestionSetDef {
  questions: number[];

  preamble?: number;
  caption?: string;  // likely deprecated... from sample questions

  hasCalculator?: boolean;
  hasFormulas?: boolean;
  isShuffleDisabled?: boolean;
  isTimeLimit?: boolean;
  isConditional?: boolean;
  timeLimitMinutes?: number;
  conditionOnItem?: string;
  conditionOnOption?: string;
  notepadText?: string;
}

export interface ISectionDef extends IQuestionSetDef {
  sectionId?:number,
  __meta?: ISectionMeta;  // likely deprecated... from sample questions
  hasWellnessBreak?:boolean;
  is_attestation?:boolean,
}

export interface IPanelModuleDef extends IQuestionSetDef {
  moduleId: number,
}

export interface ITestMeta {
  qs?: number; // how many questions are in the test
}
export interface ISectionMeta {
  qs?: number; // how many questions are in the current section
  qsPrec?: number; // how many questions appear
  markLoc?: string; // % value indicating where the marker should be placed
}

export interface IDur {
  hours: number,
  minutes: number
}

export const renderDur = (durObj: IDur, lang: LangService) => {
  return `${durObj.hours} ${lang.tra('txt_hours')} ${durObj.minutes} ${lang.tra('txt_minutes')}`
}





@Component({
  selector: 'view-tt-test-runner',
  templateUrl: './view-tt-test-runner.component.html',
  styleUrls: ['./view-tt-test-runner.component.scss']
})
export class ViewTtTestRunnerComponent implements OnInit, OnDestroy {
  private copyEventListener: () => void;
  private cutEventListener: () => void;
  private pasteEventListener: () => void;

  confirmReportData: Object = {};
  regularTimeRemaining: IDur;
  extraTimeRemaining: string;
  isNotYetOpen: boolean;
  timeTillOpen: IDur;
  dateTimeStart: moment.Moment;//the official start time of testattempt
  testAttemptInfo: ITestAttemptRes;
  testTakerName: string;
  attemptKey: string;
  isIssueReportingEnabled: boolean;
  unknownWarningErrorMsg: string;
  subscription = new Subscription();
  timeSpentSinceStart: number;
  attemptStartedOn : moment.Moment; //when the test-taker actually starts the testattempt
  report: IReport;
  reportError: boolean;
  reportErrorMsg: any;
  isOnBreak: boolean = false;
  public currentAttemptHash: string;
  constructor(
    private auth: AuthService,
    private routes: RoutesService,
    private route: ActivatedRoute,
    private loginGuard: LoginGuardService,
    public my: MyApplAccountService,
    private breadcrumbsService: BreadcrumbsService,
    private router: Router,
    public lang: LangService,
    public timezone: TimezoneService,
    private seb: SEBService,
    private mptConnection: MptConnectionService, // needed to call constructor
    private sanitizer: DomSanitizer,
    private remoteProctoringService: RemoteProctoringService
  ) { }

  public breadcrumb: IBreadcrumbRoute[] = [];
  public sessionId: number;
  public instit_group_id: number;
  public institution: number;
  public  format: string;
  public testDesign: ITestDesignPayload;
  public questionSrcDb;
  public testLang: string;
  public serverOffset: number;
  public isLoadingAttempt: boolean;
  public WarningModes = WarningModes;
  public isLoaded: boolean;
  public time_ext_m = 0;
  public test_window_time = 0;
  public asmtFmrk: IAssessmentFrameworkDetail;

  private isInited: boolean;
  private routeSub: Subscription;

  public currentWarning = null;

  public attestationSteps = attestationStepsDuringTest;
  public hasAccepted: boolean = false;

  private sessionInvitCode: string;

  public isVideoOnline: boolean = false;

  public documentItems: { itemId: number, caption: string }[] = [];

  renderDur = renderDur;

  ngOnInit() {
    this.loginGuard.activate();
    this.breadcrumb = [
      this.breadcrumbsService.APPLICANT_LANDING(),
      this.breadcrumbsService.APPLICANT_DASHBOARD(),
      this.breadcrumbsService._CURRENT( this.lang.tra('booknow_btn'), this.router.url),
    ];
    this.routeSub = this.route.params.subscribe(routeParams => {
      this.sessionId = parseInt(routeParams['sessionId']);
      this.initRouteView();
    });
   }

  ngOnDestroy() {
    if (this.routeSub) {
      this.routeSub.unsubscribe();
    }
    if (this.subscription) {
      this.subscription.unsubscribe();
    }

    // Clean up video event listeners
    this._removeVideoEventListeners();

    if (this.videoCheckInterval) {
      clearInterval(this.videoCheckInterval);
    }

    if (this.messageEventSubscription) {
      this.messageEventSubscription.unsubscribe();
    }
  }

  initRouteView() {
    this.subscription.add(
      this.my.sub().subscribe(info => {
        if (info) {
          this.isInited = true;
          this.loadAttempt();
        }
      })
    );
    const processSocketReconnection = () => this.mptConnection.disconnect();
    setInterval(processSocketReconnection, 3300000);
  }

  /* acceptAttestation(){
    const test_session_id = this.getTestSessionId();
    this.auth.apiCreate(
      this.routes.TEST_TAKER_INVIGILATION_TEST_ATTEMPT_ATTEST,
      { test_session_id }
    )
    .then(()=>{
      this.loadAttempt();
    })
  } */
  public acceptAttestation(test_session_id: number){
    return this.auth.apiCreate(
      this.routes.TEST_TAKER_INVIGILATION_TEST_ATTEMPT_ATTEST,
      { test_session_id }
    )
  }

  selectTestLang(lang: string) {
    const test_session_id = this.getTestSessionId();
    this.loginGuard.confirmationReqActivate({
      caption: this.lang.tra('txt_confirm_lang_test_select', lang),
      btnProceedCaption: this.lang.tra('lbl_yes', lang),
      btnCancelCaption: this.lang.tra('btn_cancel', lang),
      confirm: () => {
        this.auth.apiCreate(
          this.routes.TEST_TAKER_INVIGILATION_TEST_ATTEMPT_LANG,
          { test_session_id, lang }
        )
        .then(()=>{
          this.lang.loadInLang(lang); //Update the route parameters with new lang and load in the new test attempt
        })
      }
    });
  }

  getTestSessionId(){
    return parseInt('' + this.sessionId);
  }

  loadAttempt() {
    this.isLoadingAttempt = true;
    const test_session_id: number = this.getTestSessionId();
    const sebFailSafe: number = this.seb.getSEBFaileSafeCheck();
    const validatedSEBConfig:number = this.auth.getSEBValidatorStatus();
    const requestStart = Date.now(); // to calculate the amount of time it took to get the request duration to exclude from the offset
    return this.auth
      .apiFind(
        this.routes.TEST_TAKER_INVIGILATION_TEST_ATTEMPT,
        { query: {test_session_id, sebFailSafe, validatedSEBConfig} }
      )
      .then((res: ITestAttemptRes[]) => {
        const requestEnd = Date.now(); // to calculate the amount of time it took to get the request duration to exclude from the offset
        const requestDuration = requestEnd - requestStart;
        const requestLatency = requestDuration / 2; //download and upload is roughly estimated at 50/50 with the worst case scenario is 1 second off.
        this.serverOffset = (res[0].serverTime + requestLatency) - requestEnd ;
        const testAttemptInfo = res[0];
        this.testAttemptInfo = testAttemptInfo;
        const testDesign = testAttemptInfo.testDesign;
        this.testDesign = {sections: testDesign.sections, helpPageId__cache:testDesign.helpPageId__cache},
        this.documentItems = testDesign.referenceDocumentPages || [];
        this.testLang = testAttemptInfo.lang;
        this.dateTimeStart = this.timezone.moment(testAttemptInfo.date_time_start);
        this.attemptStartedOn = this.timezone.moment(testAttemptInfo.startedOn);
        this.testTakerName = this.my.getDisplayName();
        this.attemptKey = testAttemptInfo.attempt_key;
        this.isIssueReportingEnabled = testAttemptInfo.is_issue_reporting_enabled === 1;
        this.questionSrcDb = new Map();
        this.time_ext_m = testAttemptInfo.time_ext_m;
        this.test_window_time = testAttemptInfo.test_window_time;
        this.currentAttemptHash = testAttemptInfo.attempt_hash

        this.sessionInvitCode = testAttemptInfo.session_invit_code;
        try {
          this.asmtFmrk = JSON.parse(testAttemptInfo.framework);
        } catch (error) {
          this.asmtFmrk = null;
        }
        this.documentItems = this.asmtFmrk?.referenceDocumentPages || [];
        this.updateTimeRemaining();
        setInterval(this.updateTimeRemaining, 1000);
        //set values for confirmReportData
        this.confirmReportData["prevSessionMeta"] = testAttemptInfo.sections_meta
        this.confirmReportData["attemptId"] = testAttemptInfo.attemptId;
        this.confirmReportData["dateTimeStart"] = this.dateTimeStart;
        this.confirmReportData["attemptStartedOn"] = this.attemptStartedOn;
        this.confirmReportData['attemptKey'] = this.attemptKey;

        this.auth.apiFind(this.routes.TEST_TAKER_TEST_SESSIONS_BOOKING, {query: {include_instit_info: true}}).then(session => {
          if (session.length > 0) {
            /* This is supposed to be assigned to a variable called test_session_group_id*/
            this.instit_group_id = session[0].testSession.test_session_group_id;

            this.format = session[0].testSession.room;
            this.institution = session[0].institution.name;
            this.confirmReportData["format"] = this.format;
            this.confirmReportData["invigilator"] =this.institution;
          }



          Object.keys(testDesign.questionDb).forEach(questionId => {
            try {
              const question = testDesign.questionDb[questionId];
              question.test_question_version_id = questionId;
              this.questionSrcDb.set(+questionId, question);
            } catch (err) {
              console.warn('could not process question id', questionId, err);
            }
          });

          // moved the verification status tracking as part of the returned attempt without blocking its loading
          if(testAttemptInfo.is_not_verified){
            this.unknownWarningErrorMsg = WarningModes.NOT_VERIFIED;
            this.currentWarning = WarningModes.NOT_VERIFIED;
          }else{
            this.currentWarning = null;
            this.isLoaded = true;
            if (this.isRemoteEmbedded()) {
              console.log('trying to open link in loadAttempt');
              this.openVideoGroupCall();
            }
          }
          if(testAttemptInfo.is_on_break){
            this.isOnBreak = true;
          }
          this.isLoadingAttempt = false;
        });
      })
      .catch(e => {
        this.isLoadingAttempt = false;
        this.currentWarning = this.parseAttemptLoadErrorMessage(e.message);
      });
  }

  durIsZero(durObj: IDur) {
    return durObj.hours === 0 && durObj.minutes === 0
  }
  updateTimeRemaining = () => {
    const totalTime = this.test_window_time + this.time_ext_m;
    const leadingZero = (num: number) => {
      let str = '' + Math.floor(num);
      if (str.length === 1) {
        return '0' + str;
      }
      return str;
    };


    const getDurObj = (timeSinceStart_m: number, totalTime= 0) => {
      const timeRemaining_m = Math.abs(totalTime - timeSinceStart_m);
      const timeRemaining_h = Math.floor(timeRemaining_m / 60);
      const timeRemaining_m_r = Math.floor(timeRemaining_m - timeRemaining_h * 60);
      return {hours: timeRemaining_h, minutes: timeRemaining_m_r};
    };

    let timeSinceStart_ms =  - this.dateTimeStart.diff(moment.utc().tz(this.timezone.getTimezone()));
    timeSinceStart_ms = timeSinceStart_ms + this.serverOffset;
    const timeSinceStart_m = (timeSinceStart_ms / 1000) / 60;

    this.isNotYetOpen = (timeSinceStart_ms < 0);
    if (this.isNotYetOpen) {
      this.timeTillOpen = getDurObj(-timeSinceStart_m);
    }
    if (timeSinceStart_m >= totalTime) {
        this.regularTimeRemaining = {hours: 0, minutes: 0};
      } else {
        this.regularTimeRemaining = getDurObj(timeSinceStart_m, totalTime);
      }
    this.timeSpentSinceStart= timeSinceStart_m;
    this.confirmReportData["timeSpent"] = this.timeSpentSinceStart;
  }

  public saveQuestionResponse = (data: any) => {
    return this.auth.apiCreate(
      this.routes.TEST_TAKER_INVIGILATION_QUESTION_RESPONSE,
      {
        ... data,
        test_attempt_id:  this.testAttemptInfo.attemptId,
      }
    );
  }

  public checkTime = () => {
    const test_session_id: number = parseInt('' + this.sessionId);
    const sebFailSafe: number = this.seb.getSEBFaileSafeCheck();
    const validatedSEBConfig:number = this.auth.getSEBValidatorStatus();
    return this.auth.apiFind(
      this.routes.TEST_TAKER_INVIGILATION_TEST_ATTEMPT_TIME,
      { query: {test_session_id, sebFailSafe, validatedSEBConfig} }
    )
    . then( time => {
      this.time_ext_m = time[0].time_ext_m;
    });
  }

  public checkChat = () => {
    return Promise.resolve();
  }

  public updateWellnessBreak = (take_break: boolean) => {
    const test_session_id = this.getTestSessionId();
    return this.auth.apiCreate(
      this.routes.TEST_TAKER_INVIGILATION_WELLNESS_BREAK,
      {
        test_session_id: test_session_id,
        isTakingWellnessBreak: take_break == true ? 1 : 0,
        isAntiTakingWellnessBreak: take_break == false ? 1 : 0
      }
    ).catch(e => {
      this.loginGuard.quickPopup("tt_wellness_break_err_popup");
    });
  }

  public submitTest = () => {
    return this.auth.apiPatch(
      this.routes.TEST_TAKER_INVIGILATION_QUESTION_RESPONSE, // bad name ... to do
      1,
      { test_attempt_id:  <any> this.testAttemptInfo.attemptId },
      { query:{domain: getFrontendDomain()} }
    )
    .then( r => {
      this.mptConnection.updateCompleted(this.auth.user().value.uid, true);
      /*
      this.auth
      .apiGet(this.routes.TEST_TAKER_REPORT_RESULTS, this.confirmReportData["attemptId"], {query: {getreport: true}})
      .then((report: IReport) => {
        this.report = report;
        //console.log(this.report)
      } )
      .catch(e => {
         this.reportError = true;
         this.reportErrorMsg = this.parseLoadError(e.message);
         //console.log(this.reportErrorMsg)
      });
      */
      this.my.gotoDashboard();
    });
  }

  parseLoadError(msg) {
    switch (msg) {
      case 'WRONG_USER': return this.lang.tra('txt_error_login');
      case 'NOT_YET_RELEASED': return this.lang.tra('txt_res_unavail');
      default: return 'An error occured while loading your results';
    }
  }

  public goBack() {
    this.router.navigate([
      this.lang.c(),
      AccountType.TEST_TAKER,
      'dashboard'
    ]);
  }

  public refresh() {
    window.location.reload();
  }


  isInSelectionStep(currentWarning:WarningModes){
    switch(currentWarning){
      case WarningModes.SELECT_LANG:
      case WarningModes.ACCEPT_ATTEST:
        return true;

      default: return false;
    }
  }

  private parseAttemptLoadErrorMessage(message: string) {
    switch (message) {

      case WarningModes.INVALID_SEB:
      case 'SEB header used but no matching available SEB headers found for this institution':
      case 'SEB header hash matched but is revoked':
      case 'SEB header does not match expected hash':
      case 'Missing SEB header':
        this.unknownWarningErrorMsg = message;
        return WarningModes.INVALID_SEB;
      case ApiFailCode.GROUP_ROLE_REQ_FOR_ROUTE:
        return WarningModes.NOT_BOOKED_APPL;
      // to do: ideally every
      case WarningModes.NO_QUESTIONS_FOUND:
      case WarningModes.SELECT_LANG:
      case WarningModes.ACCEPT_ATTEST:
        return <WarningModes> message;

      case 'Missing Institution ID':
      default :
        this.unknownWarningErrorMsg = message;
        return WarningModes.UNKNOWN;
    }
  }

  updateAcceptance() {
    this.hasAccepted = this.attestationSteps.every(step => step.is_checked == true);
  }

  logout() {
    this.auth.logout() .then( r => {
      window.location.reload();
    });
  }

  public verificationRoomId: string;
  public startVideo: boolean = false;
  public callLink: string | SafeResourceUrl;
  private videoStatusCheckInterval: any;
  public isVideoConnected: boolean = false;
  videoCheckInterval: any;
  videoStatusFromMessages: boolean = false; // used to track if video status was received from messages
  public ttName: string = ''; // used to set the name

  async openVideoGroupCall() {
    const thisSessionId = this.sessionId;

    this.ttName = this.remoteProctoringService.formatUsername(this.testTakerName);
    this.verificationRoomId = this.remoteProctoringService.generateRoomId(thisSessionId, this.sessionInvitCode);

    if (!await this.remoteProctoringService.isRoomReady(this.verificationRoomId)) {
      this._handleInactiveRoom();
    }

    const cLang = this.testLang || 'en';
    const urlStringSfu = `${MPT_REMOTE_PROCTOR_DOMAIN}/join?room=${this.verificationRoomId}&name=${this.ttName}&avatar=0&audio=0&video=1&screen=0&hide=0&notify=0&lang=${cLang}`;

    // Use remote link for testing and demo
    const callLinkSani = this.sanitizer.bypassSecurityTrustResourceUrl(urlStringSfu);
    this.callLink = callLinkSani; // can't IFrame on http lcoal for now, permissions not triggered

    this._setupMirotalkMessageEventListeners()

    // check video status on page
    this._checkCurrentVideoStream();
    this.videoCheckInterval = setInterval(() => this._checkCurrentVideoStream(), 5000);

    setTimeout(() => {
      console.log('opening video link', urlStringSfu);
      this.startVideo = true;
    }, 1000);
  }

  _handleVideoStatusUpdate(isVideoOn: boolean) {
    console.log("🚀 ~ view-tt-test-runner.component.ts:607 ~ ViewTtTestRunnerComponent ~ handleVideoStatusUpdate ~ isVideoOn:", isVideoOn)
    this.videoStatusFromMessages = isVideoOn;
  }

  audioStatusFromMessages: boolean = false; // used to track if audio status was received from messages
  _handleAudioStatusUpdate(data: any) {
    this.audioStatusFromMessages = data.isAudioOn;
  }

  /**
   * OR better to redirect with a pop-up?
   * @param data
   */
  _handleInactiveRoom() {
    console.log('ROOM NOT READY - SENDING ERROR')
    this.isLoaded = false;
    this.currentWarning = this.parseAttemptLoadErrorMessage('SESSION_NOT_READY');
  }

  checkVideoStatus() {
    try {
      const iframe = document.querySelector('iframe');
      if (!iframe) {
        this.isVideoConnected = false;
        return;
      }

      try {
        const iframeDoc = iframe.contentDocument || iframe.contentWindow?.document;

        // If we got this far without error, the iframe is loaded
        this.isVideoConnected = true;

        // Check for specific DOM elements that indicate an active connection
        // For example, MiroTalk might have elements with specific classes when connected
        const connectedIndicator = iframeDoc?.querySelector('.connection-status.connected');
        if (connectedIndicator) {
          this.isVideoConnected = true;
        } else {
          const disconnectedIndicator = iframeDoc?.querySelector('.connection-status.disconnected');
          this.isVideoConnected = !!disconnectedIndicator;
        }
      } catch (e) {
        // Cross-origin error, can't access iframe content directly
        // Fall back to checking if the iframe is still in the DOM
        this.isVideoConnected = !!iframe;
      }
    } catch (error) {
      console.warn('Error checking video status:', error);
      this.isVideoConnected = false;
    }
  }

  public getVideoLink() {

  }
  public refreshConference () {
    if (this.startVideo && this.callLink) {
      // Force iframe reload by toggling the src
      this.startVideo = false;
      setTimeout(() => {
        this.startVideo = true;
        console.log("Video iframe reloaded");
      }, 500);
    }
  }


  messageEventSubscription: Subscription = new Subscription();
  public mirotalkEvent$: Observable<MirotalkMessageEvent> | null = null;
  /**
   * Sets up event listeners for video conference debugging and status tracking
   */
  private _setupMirotalkMessageEventListeners(): void {
    console.log('SETTING UP MIROTALK EVENT LISTENER ON TT-TEST-RUNNER')
    // Remove existing listeners to prevent duplicates
    this._removeVideoEventListeners();

    // Standard postMessage events
    this._messageEventHandler = (event: MessageEvent) => {
      console.log("📨 Standard message event:", event);
      this._handleMirotalkMessages(event);
    };

    // Add message event listener
    this.mirotalkEvent$ = this.remoteProctoringService.listenMirotalkEventMessage();

    this.messageEventSubscription.add(
      this.mirotalkEvent$.subscribe(this._messageEventHandler)
    );

  }

  private _removeVideoEventListeners(): void {
    if (this._messageEventHandler) {
      window.removeEventListener("message", this._messageEventHandler);
    }
    if (this.messageEventSubscription) {
      this.messageEventSubscription = new Subscription();
      this._messageEventHandler = null;
    }
  }

  /**
   * Event handler function, references for proper cleanup
   */
  private _messageEventHandler: ((event: MessageEvent) => void) | null = null;

  /**
   * Performs comprehensive video status check using multiple detection methods
   */
  private _performVideoStatusCheck(): void {
    try {
      const iframe = document.getElementById("iframe-video-verification") as HTMLIFrameElement;
      if (!iframe) {
        console.log("🚨 Video iframe not found in DOM");
        this.isVideoOnline = false;
        return;
      }

      // Check if iframe is still loading
      if (!iframe.src || iframe.src === "about:blank") {
        console.log("⏳ Video iframe is loading or blank");
        this.isVideoOnline = false;
        return;
      }

      // Basic check: iframe exists and has valid src
      const hasValidSrc = iframe.src.includes(MPT_REMOTE_PROCTOR_DOMAIN) || iframe.src.includes("mirotalk") || iframe.src.includes("localhost:3010");

      if (hasValidSrc) {
        console.log("✅ Video iframe has valid source URL");
        // Don't automatically set to true here - wait for actual connection confirmation
      } else {
        console.log("❌ Video iframe has invalid or missing source");
        this.isVideoOnline = false;
      }

      // Try to detect if iframe has loaded content (CORS will prevent deep inspection)
      try {
        const iframeDoc = iframe.contentDocument;
        if (iframeDoc) {
          console.log("🔍 Iframe document accessible (same-origin)");
          // If we can access the document, check for connection indicators
          const bodyElement = iframeDoc.body;
          if (bodyElement && bodyElement.children.length > 0) {
            console.log("📄 Iframe has loaded content");
          }
        }
      } catch (corsError) {
        // Expected for cross-origin iframes
        console.log("🔒 Iframe content blocked by CORS (normal for MiroTalk)");
      }

    } catch (error) {
      console.error("🚨 Error during video status check:", error);
      this.isVideoOnline = false;
    }
  }

  /**
   * Enhanced video message handler with better error handling and logging
   * @param event - The message event received from the video iframe type
   */
  private _handleMirotalkMessages = (event: MirotalkMessageEvent): void => {
    console.log("🚀 ~ view-tt-test-runner.component.ts:746 ~ ViewTtTestRunnerComponent ~ event:", event)
    try {
      if (event.data.type === MIROTALK_EVENT_MESSAGE) {
        console.log('📡 Received data from MiroTalk:', event.data);

        // For online indicator need to filter messages with current user name
        if (event.data.data.peer_name && event.data.data.peer_name !== this.ttName) return;

        switch (event.data.event) {
          case MIROTALK_MESSAGE_EVENT_LIST.VIDEO_STATUS_CHANGED:
            console.log('video status changed:', event.data);
            this._handleVideoStatusUpdate(event.data.data.isVideoOn);
              // handlePeerStatusUpdate(event.data);
              break;
          case MIROTALK_MESSAGE_EVENT_LIST.AUDIO_STATUS_CHANGED:
            console.log('audio status changed:', event.data.data.isAudioOn);
            this._handleAudioStatusUpdate(event.data.data);
              // handleMiroTalkConnected(event.data);
              break;
          // case 'updatePeerInfo': //handles closing audio, audio on
          //   console.log('updatePeerInfo:', event.data);
          //     break;
          // case 'producerClosed':
          //   console.log('producerClosed:', event.data);
          //     break;
          // case 'produce':
          //   console.log('produce:', event.data);
          //   break;
        }
      }

      // Validate origin for security
      const validOrigins = [
        "mirotalk.com",
        MPT_REMOTE_PROCTOR_DOMAIN,
        "localhost:3010",
        "host:3010"
      ];

      const isValidOrigin = validOrigins.some(origin => event.origin.includes(origin));
      if (!isValidOrigin) {
        console.warn("⚠️ Message from invalid origin:", event.origin);
        return;
      }

    } catch (error) {
      console.error("🚨 Error handling video message:", error);
    }
  };

  isVideoStreamOnline: boolean = false;
  _checkCurrentVideoStream() {
    navigator.mediaDevices.getUserMedia({ video: true })
      .then((stream) => {
        // console.log("🚀 ~ view-tt-test-runner.component.ts:1392 ~ ViewTtTestRunnerComponent ~ .then ~ stream:", stream)
       // Check if stream is active
        if (stream.active) {
          // console.log("✅ Stream is active and producing data");
          this.isVideoStreamOnline = true;

          // Additional check: examine individual tracks
          const videoTracks = stream.getVideoTracks();
          const activeTracks = videoTracks.filter(track => track.readyState === "live");

          // console.log(`📹 Video tracks: ${videoTracks.length} total, ${activeTracks.length} active`);

          // Verify at least one video track is actively producing
          if (activeTracks.length > 0) {
            // console.log("🎥 Video is confirmed available and active");
            this.isVideoStreamOnline = true;
          } else {
            console.warn("⚠️ Stream active but no live video tracks");
            this.isVideoStreamOnline = false;
          }
        } else {
          console.warn("⚠️ Stream obtained but not active");
          this.isVideoStreamOnline = false;
        }
        stream.getTracks().forEach(track => track.stop()); // Stop the stream to release camera
      })
      .catch((error) => {
        console.error("Video is not available:", error);
        this.isVideoStreamOnline = false;
      });
  }
  checkIfVideoIsOnline() {
    this.isVideoOnline = this.isVideoStreamOnline && this.videoStatusFromMessages;
    return this.isVideoOnline;
  }
  public isRemote() {
    if (this.testAttemptInfo && this.testAttemptInfo.delivery_format) {
      return this.testAttemptInfo.delivery_format === EDeliveryOption.REMOTE;
    } else return false;
  }

  public isRemoteEmbedded() {
    if (this.testAttemptInfo && this.testAttemptInfo.delivery_format) {
      return this.testAttemptInfo.delivery_format === EDeliveryOption.REMOTE_EMBEDDED;
    } else return false;
  }

  tempCloseConfOnPrivateCall(value: boolean) {
    console.log('RECEIVED INFO TO CHANGE CONF CALL STATUS', value)
    if (value) {
      this.isVideoOnline = false;
      this.isVideoConnected = false;
      this.startVideo = false;
      // this.callLink = '';
      this._removeVideoEventListeners();
      if (this.videoCheckInterval) {
        clearInterval(this.videoCheckInterval);
      }
    } else {
      this.isVideoOnline = true;
      this.isVideoConnected = true;
      this.startVideo = true;
      // this.callLink = this.sanitizer.bypassSecurityTrustResourceUrl(this.callLink);
      this._setupMirotalkMessageEventListeners();
      // Restart video check interval
      if (this.videoCheckInterval) {
        clearInterval(this.videoCheckInterval);
      }
      this.videoCheckInterval = setInterval(() => this._checkCurrentVideoStream(), 5000);
    }
  }
}
